import { render } from "./reform.vue?vue&type=template&id=74d99cb5&scoped=true"
import script from "./reform.vue?vue&type=script&lang=js"
export * from "./reform.vue?vue&type=script&lang=js"

import "./reform.vue?vue&type=style&index=0&id=74d99cb5&lang=less&scoped=true"

import exportComponent from "D:\\work\\ask_cloud\\QC\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74d99cb5"]])

export default __exports__